// extracted by mini-css-extract-plugin
export default {"search-users-container":"styles_search-users-container__tsdus","user-found":"styles_user-found__ulIwK","label":"styles_label__AsHX9","search-input":"styles_search-input__va1rb"};